import { create } from 'zustand';

import { type ApiErrorResponse, isApiErrorResponse, parseApiError } from '@/lib/api-error';

interface ErrorDialogState {
	error: ApiErrorResponse | null;
	isOpen: boolean;
	showError: (error: unknown) => void;
	clearError: () => void;
}

export const useErrorDialogStore = create<ErrorDialogState>((set) => ({
	error: null,
	isOpen: false,

	showError: (err) => {
		const apiError = isApiErrorResponse(err) ? err : parseApiError(err);

		if (apiError) {
			set({ error: apiError, isOpen: true });
		}
	},

	clearError: () => {
		set({ isOpen: false });
		setTimeout(() => set({ error: null }), 200);
	},
}));
